import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { useSaveCompanyDataJ } from '../../../services/hooks/useSaveCompanyData';
import { fetchAllPortCos } from '../../../services/queries/MaggieCompanyQueries';
import { portcoIdsStateJ } from '../../../services/state/PortCosStateJ';

// saves portfolio company data in state and sets portcoIdsStateJ
export function usePortCos() {
  const [loading, setLoading] = useState(true);
  const [dataReady, setDataReady] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [data, setData] = useState<ICompanyDataModel[]>();

  const fetchAndSavePortCos = useFetchAndSavePortCos();

  useEffect(() => {
    let cancelled = false;

    fetchAndSavePortCos()
      .then((res) => {
        if (cancelled) {
          return;
        }
        setDataReady(true);
        setData(res);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [fetchAndSavePortCos]);

  return { loading, dataReady, error, fetchAndSavePortCos, data };
}

export function useFetchAndSavePortCos() {
  const batchSaveCompanyDataJ = useSaveCompanyDataJ();
  const setPortCoIdsJ = useSetAtom(portcoIdsStateJ);

  return useCallback(async () => {
    const data = await fetchAllPortCos();
    // Populate `companyStateJ`'s sync cache before broadcasting the ids so
    // `portcosAtomJ` derives its list from already-resolved companies and
    // does not fall back to per-id fetches.
    batchSaveCompanyDataJ(data);
    setPortCoIdsJ(data.map((company) => company.id));
    return data;
  }, [batchSaveCompanyDataJ, setPortCoIdsJ]);
}
